import { render, staticRenderFns } from "./DashboardSchoolHeader.vue?vue&type=template&id=4e73a9b6&scoped=true&"
import script from "./DashboardSchoolHeader.vue?vue&type=script&lang=js&"
export * from "./DashboardSchoolHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSchoolHeader.vue?vue&type=style&index=0&id=4e73a9b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e73a9b6",
  null
  
)

export default component.exports